import type {
  StyleValue,
  StyleValueMeta,
} from "@circle-react-shared/BuilderUI/StyleValue.types";
import { DesignProp } from "@circle-react-shared/BuilderUI/constants/PropCategories";

interface StyleOption {
  label: string;
  labelI18n: string;
  value: string;
}

export const getListStyleTypeOptions = (
  defaultValue: string = "disc",
): StyleValue => {
  const options: StyleOption[] = [
    {
      label: "Disc",
      labelI18n: "builder_ui.prop_type.styles.list_style_type_options.disc",
      value: "disc",
    },
    {
      label: "Circle",
      labelI18n: "builder_ui.prop_type.styles.list_style_type_options.circle",
      value: "circle",
    },
    {
      label: "Square",
      labelI18n: "builder_ui.prop_type.styles.list_style_type_options.square",
      value: "square",
    },
    {
      label: "None",
      labelI18n: "builder_ui.prop_type.styles.list_style_type_options.none",
      value: "none",
    },
  ];

  const meta: StyleValueMeta = {
    name: "List style type",
    nameI18n: "builder_ui.prop_type.styles.list_style_type",
    category: [DesignProp],
    options,
  };

  return {
    type: "select",
    value: defaultValue,
    meta,
  };
};

export const getListStylePositionOptions = (
  defaultValue: string = "outside",
): StyleValue => {
  const options: StyleOption[] = [
    {
      label: "Outside",
      labelI18n:
        "builder_ui.prop_type.styles.list_style_position_options.outside",
      value: "outside",
    },
    {
      label: "Inside",
      labelI18n:
        "builder_ui.prop_type.styles.list_style_position_options.inside",
      value: "inside",
    },
  ];

  const meta: StyleValueMeta = {
    name: "List style position",
    nameI18n: "builder_ui.prop_type.styles.list_style_position",
    category: [DesignProp],
    options,
  };

  return {
    type: "select",
    value: defaultValue,
    meta,
  };
};
